import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { browserHistory } from 'react-router';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import imageSourceType from '../../../js/imageSourceTypes';
import { reliablyHandleAsyncFormSubmit } from '../../common/formUtils';
import { setImageDestinationLocation } from '../../../js/actions/imagingWorkflowActionCreators';
import { requestImageDestinationLocationValidation } from  '../../../js/actions/imageLocationActionCreators';
import selectionElementMode from '../../common/selectionElementMode';
import InlineValidationMessage from '../../common/InlineValidationMessage';
import FormErrorNotification from '../../common/FormErrorNotification';
import ImageDestinationLocationSelection from '../../common/ImageDestinationLocationSelection';
import LoaderWithText from '../../common/LoaderWithText';
import BackLink from '../../common/BackLink';

const validationStatus = {
    success: 'success',
    failed: 'failed',
    cancelled: 'cancelled'
};

const validate = (values) => {
    const errors = {};

    if(isUndefinedNullOrEmpty(values.storagelocationpath)){
        errors.storagelocationpath = 'Enter a destination folder';
    }

    return errors;
};

const renderImageDestinationLocationSelectionField = (props) => {
    return <div>
        <ImageDestinationLocationSelection forAgent={props.agentId} value={props.input.value} autoFocus={props.autoFocus} onChange={props.input.onChange} onModeChanged={props.onModeChanged} />
        <InlineValidationMessage touched={props.meta.touched} error={props.meta.error} />
    </div>;
};

const ImageDestinationForm = React.createClass({
    setValidationSuccedded: null,
    setValidationFailed: null,
    getInitialState: function() {
        return {
            validationOperationIdToTrack: null,
            validationStatus: null,
            isOnImageDestinationAddMode: false
        };
    },
    componentWillReceiveProps: function(nextProps) {
        const { getOperation } = nextProps;
        const { validationOperationIdToTrack } = this.state;

        if(!isUndefinedNullOrEmpty(validationOperationIdToTrack)) {
            const operation = getOperation(validationOperationIdToTrack);
            if(!isUndefinedNullOrEmpty(operation) && !isUndefinedNullOrEmpty(operation.resultDetails)) {
                const { resultDetails } = operation;
                if(resultDetails.isSuccess === true) {
                    this.setValidationSuccedded();
                } else {
                    this.setValidationFailed(resultDetails.errorMessage);
                }

                this.setState({
                    validationOperationIdToTrack: null,
                    validationStatus: resultDetails.isSuccess ? validationStatus.success : validationStatus.failed
                });
            }
        }
    },
    onImageDestinationModeChanged: function(mode) {
        this.setState({ isOnImageDestinationAddMode: mode === selectionElementMode.add });
    },
    onValid: function(data) {
        const { storageLocations, selectedAgentId, onFormValid, startImageDestinationValidation } = this.props;
        const imageDestination = storageLocations.get(data.storagelocationpath);

        return reliablyHandleAsyncFormSubmit(() => {
            this.setState({ validationStatus: null });
            return startImageDestinationValidation(selectedAgentId, imageDestination.uncPath).then((operationDetails) => {
                this.setState({ validationOperationIdToTrack: operationDetails.id });
                return new Promise((resolve, reject) => {
                    this.setValidationSuccedded = resolve;
                    this.setValidationFailed = reject;
                });
            }).then(() => {
                onFormValid(imageDestination);
                browserHistory.push('/images/create/review');
            });
        });
    },
    render: function () {
        const { handleSubmit, error, pristine, submitting, valid, selectedAgentId } = this.props;
        const { isOnImageDestinationAddMode } = this.state;

        return <form onSubmit={handleSubmit(this.onValid)}>
            <div>
                <div className="form-container">
                    <BackLink />
                    {!isOnImageDestinationAddMode && <h1 className="destinationTitle">Image destination</h1>}

                    <FormErrorNotification error={error} />

                    <div className="control-holder">
                        <Field name="storagelocationpath" placeholder="Select a folder" autoFocus agentId={selectedAgentId} onModeChanged={this.onImageDestinationModeChanged} component={renderImageDestinationLocationSelectionField} />
                    </div>

                    {(!isOnImageDestinationAddMode && valid && !pristine) &&
                        <button type="submit" className="button button--primary" disabled={submitting}>
                            Next
                        </button>
                    }

                    {submitting && <div className="control-holder">
                        <LoaderWithText loadingText="Checking access for image storage location" />
                    </div>}
                </div>
            </div>
        </form>;
    }
});

const mapStateToProps = (state) => {
    const { imageCreation } = state.app;
    const sourceType = imageCreation.source;
    const sourceLocationId = imageCreation.sourceLocation.id;

    const selectedSqlServerInstance = sourceType === imageSourceType.sqlServer ?
        state.sqlServerInstances.value.get(sourceLocationId) :
        state.sqlServerInstances.value.get(state.backupLocations.value.get(sourceLocationId).temporaryInstanceId);

    return {
        imageCreation: imageCreation,
        storageLocations: state.imageDestinationLocations.value,
        selectedAgentId: selectedSqlServerInstance.agentId,
        getOperation: (operationId) => state.operations.value.get(operationId)
    };
};

const mapDispatchToProps = (dispatch) => ({
    onFormValid: (data) => {
        dispatch(setImageDestinationLocation(data.id, data.uncPath, ['']));
    },

    startImageDestinationValidation: (agentId, uncPath) => {
        return dispatch(requestImageDestinationLocationValidation({
            agentId: agentId,
            uncPath: uncPath
        }));
    }
});

const component = connect(mapStateToProps, mapDispatchToProps)(ImageDestinationForm);
component.title = 'Image Destination Form';

export default reduxForm({ form: 'ImageDestinationForm', validate })(component);


// WEBPACK FOOTER //
// ./src/components/imaging/ImageDestinationPage/imageDestinationForm.jsx